const LIST_URL = "/v1/current/list";
const SINGLE_URL = "/v1/current/single";
const ADD_URL = "/v1/current/add";
const SALESPERSON_LIST_URL = "/v1/current/salesperson-list";
const CURRENT_ACTION_LIST_URL = "/v1/current/actions";
const CURRENT_ACTION_DETAIL_LIST_URL = "/v1/current/action/details";
const CURRENT_UNCLOSED_INVOICE_LIST_URL = "/v1/current/unclosed-invoices";
const CURRENT_APPROVAL_LIST_URL = "/v1/current/approval-list";
const CURRENT_ADMIN_APPROVE_URL = "/v1/current/admin-approve";
const CURRENT_ACCOUNTING_APPROVE_URL = "/v1/current/accounting-approve";
const CURRENT_REJECT_URL = "/v1/current/denied";
const CURRENT_OPEN_LIST_URL = "/v1/current/open-list";
const CURRENT_ACTION_DETAIL_LIST_TOTALS_URL = "/v1/current/action/detail-totals";
const CURRENT_SEARCH_URL = "/v1/current/query";
const CURRENT_CODES_LIST_URL = "/v1/current/codes-list";
const CURRENT_ACTION_DETAIL_SERIES_URL = "/v1/current/action/series";
const CURRENT_CURRENCY_LIST_URL = "/v1/current/currency-list";

const CURRENT_API_URL_LIST = {
    LIST_URL,
    SINGLE_URL,
    ADD_URL,
    SALESPERSON_LIST_URL,
    CURRENT_ACTION_LIST_URL,
    CURRENT_UNCLOSED_INVOICE_LIST_URL,
    CURRENT_ACTION_DETAIL_LIST_URL,
    CURRENT_APPROVAL_LIST_URL,
    CURRENT_ADMIN_APPROVE_URL,
    CURRENT_ACCOUNTING_APPROVE_URL,
    CURRENT_REJECT_URL,
    CURRENT_OPEN_LIST_URL,
    CURRENT_ACTION_DETAIL_LIST_TOTALS_URL,
    CURRENT_SEARCH_URL,
    CURRENT_CODES_LIST_URL,
    CURRENT_ACTION_DETAIL_SERIES_URL,
    CURRENT_CURRENCY_LIST_URL
}

export { CURRENT_API_URL_LIST };